import m from "../../geodata/es2015/polandHigh";
window.am4geodata_polandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/polandHigh.js
// module id = null
// module chunks = 